import { SPRINT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue, RichValue } from '../../../value/types.tsx';
import type { TransformedSprintField, TransformedSprintFieldOption } from '../types.tsx';

const getSprintStringValue: StringValue<TransformedSprintField> = (field) =>
	String(field.value?.map((option) => option?.name ?? '').join(', ') ?? '');

export const sprintStringValueHandler = {
	[SPRINT_TYPE]: getSprintStringValue,
};

const getSprintRichValue: RichValue<TransformedSprintField, TransformedSprintFieldOption[]> = (
	field,
) => field.value ?? [];

export const sprintRichValueHandler = {
	[SPRINT_TYPE]: getSprintRichValue,
};
